import React, { memo, FC } from "react";
import Typography from "@mui/material/Typography";
import Choices from "../../Choices";
import ReusableAccordian from "../../ReusableAccordion";
import SillFinish from "../../SillFinish/SillFinish";
import { Image, Transformation } from "cloudinary-react";
import { sliderSills, slidingScrSills, sillColor } from "./defaults";
import { RowLayout, ColLayout } from "../../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import useSillSelector from "./useSillSelector";
import { addScrollElements } from "../../AccordionWrapper/AccordianWrapper";

interface SliderSillProps {
  editQuote: boolean;
  submitPressed: boolean;
}

const ColLayoutSpacing = styled("div")(({ theme }) => ({
  marginBottom: 10,
  marginTop: 20,
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(1, 2),
}));

const ColLayoutLeftDivider = styled("div")(({ theme }) => ({
  marginBottom: 10,
  marginTop: 20,
  paddingBottom: 20,
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  borderLeft: `2px solid ${theme.palette.divider}`,
  padding: theme.spacing(1, 2),
}));

const SliderSillAccordian: FC<SliderSillProps> = () => {
  const {
    handleClickColor,
    handleClickSill,
    sillImageShown,
    showSillFinish,
    withSlidingScreen,
    sliderPocket,
    sillStyleChoice,
    sillColorChoice,
  } = useSillSelector();

  return (
    <>
      {addScrollElements(["Sill Finish", "Sill Dam Finish", "Sill Type"])}

      <ReusableAccordian
        accordionName="sill"
        heading="Sill Choice"
        secondaryHeading="Select sill choice"
        colOrRow="col"
      >
        {sillStyleChoice === "Stainless Steel Recessed *" && (
          <Typography variant="caption">* Upcharge Applies</Typography>
        )}
        <RowLayout style={{ alignItems: "flex-start" }}>
          <ColLayoutSpacing>
            <Typography style={{ margin: "auto" }} variant="subtitle1">
              Sill Types <span style={{ color: "red", fontSize: 22 }}>*</span>
            </Typography>
            <RowLayout>
              {!withSlidingScreen
                ? sliderSills.map((state) => (
                    <div
                      key={state.id}
                      onClick={() => handleClickSill(state.label)}
                    >
                      <Choices
                        label={state.label}
                        variant={
                          state.label === sillStyleChoice
                            ? "filled"
                            : "outlined"
                        }
                        checkMark={state.label === sillStyleChoice}
                        disabled={false}
                      />
                    </div>
                  ))
                : slidingScrSills.map((state) => (
                    <div
                      key={state.id}
                      onClick={() => handleClickSill(state.label, true)}
                    >
                      <Choices
                        label={state.label}
                        variant="filled"
                        checkMark={true}
                        disabled={true}
                      />
                    </div>
                  ))}
            </RowLayout>
          </ColLayoutSpacing>
          {sillStyleChoice !== "Stainless Steel Recessed *" && (
            <>
              <ColLayoutLeftDivider>
                <Typography style={{ margin: "auto" }} variant="subtitle1">
                  Sill Colors{" "}
                  <span style={{ color: "red", fontSize: 22 }}>*</span>
                </Typography>
                <RowLayout>
                  {sillColor.map((state) => (
                    <div
                      key={state.id}
                      onClick={() => handleClickColor(state.label)}
                    >
                      <Choices
                        label={state.label}
                        variant={
                          state.label === sillColorChoice
                            ? "filled"
                            : "outlined"
                        }
                        checkMark={state.label === sillColorChoice}
                        disabled={false}
                      />
                    </div>
                  ))}
                </RowLayout>
              </ColLayoutLeftDivider>

              {showSillFinish && <SillFinish />}
            </>
          )}
        </RowLayout>

        {sliderPocket === "With Pocket" && sillImageShown ? (
          <RowLayout style={{ justifyContent: "space-around", width: "70%" }}>
            <Image
              cloudName="ag-millworks"
              secure="true"
              publicId={sillImageShown}
            />

            <ColLayout>
              <Image
                cloudName="ag-millworks"
                secure="true"
                publicId="Sills/sliders/pocketing/SILL_PAN_2"
              >
                <Transformation width="450" height="250" crop="scale" />
              </Image>

              <Typography style={{ paddingTop: 10 }} variant="subtitle2">
                * Need to have 3 sided sill pan with welded corners for the
                pocket. (BY OTHERS)
              </Typography>
            </ColLayout>
          </RowLayout>
        ) : sillImageShown ? (
          <Image
            cloudName="ag-millworks"
            secure="true"
            publicId={sillImageShown}
          />
        ) : null}
      </ReusableAccordian>
    </>
  );
};

export default memo(SliderSillAccordian);
